import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { USEREMAILVERIFY } from "../../Mutation/AuthMutation"; // Import the mutation from the correct file
import Loader from '../../Components/Loader/Loader'; // Assuming this is a custom loader component
import { toast } from 'react-toastify'; // Toast for notifications

const EmailVerification = () => {
  const { token } = useParams(); // Extract token from the URL
  const navigate = useNavigate(); // To programmatically navigate the user to the login page
  const [isVerifying, setIsVerifying] = useState(true); // State to track if the verification is in progress

  // Mutation for email verification
  const [userEmailVerify] = useMutation(USEREMAILVERIFY, {
    onCompleted: () => {
      setIsVerifying(false); // Stop loader once the mutation is successful
      toast.success("Email verified successfully!"); // Show success message
      navigate("/login"); // Redirect to the login page after success
    },
    onError: (error) => {
      setIsVerifying(false); // Stop loader in case of error
      toast.error("Verification failed. Please try again."); // Show error message
      console.error("Verification error:", error); // Log the error for debugging
    }
  });

  useEffect(() => {
    if (token) {
      // Trigger the email verification mutation when the component mounts
      userEmailVerify({ variables: { token } });
    }
  }, [token, userEmailVerify]);

  return (
    <div style={{ maxWidth: '400px', margin: 'auto', textAlign: 'center', height: "50vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {isVerifying ? <Loader /> : <p>Your email has been verified!</p>} {/* Show loader while verifying */}
    </div>
  );
};

export default EmailVerification;
